import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { getIcon } from "../../../helpers/icons";
import { makeProfileData } from "../../../actions/storage";
import Link from "../../../components/Link";
import AsyncGet from "../../../components/AsyncGet";

import style from "./style.module.css";

export default function Logout () {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    return (
        <div className={style.logoutBtn}>
            <AsyncGet
                url = "/account/logout"
                permissionText="Logout"
                onFetch={() => {
                    dispatch(makeProfileData({}))
                    navigate('/sign-in');
                }}
                render={({ loadFromAPI }) => (
                    <Link
                        onClick={loadFromAPI}
                    >
                        Logout <i className={`${getIcon("Angle-right")}`}></i>
                    </Link>
                )}
            />
        </div>
    )
}